<div class="app-loading" *ngIf="appLoading">
  <div class="logo">
    <svg class="spinner" viewBox="25 25 50 50">
      <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/>
    </svg>
  </div>
</div>
<mat-nav-list>
  <input #FileSelectInputDialog style="display: none;" (change)="fileSelected($event)" type="file" accept=".pdf, .jpg, .jpeg, .png, .gif" file-handler/>
  <a mat-list-item (click)="FileSelectInputDialog.click()" file-handler>
    <span mat-line>Seleziona dal dispositivo</span>
    <span mat-line>Formati supportati: pdf, jpg, png, gif</span>
  </a>
</mat-nav-list>
